export function i18nCreateFakeLanguageResource(resource) {
    const languageExtraLength = 0.0;
    const vowelMap = {
        a: "â",
        e: "ê",
        i: "î",
        o: "ô",
        u: "û",
    };
    const result = Object.fromEntries(Object.entries(resource).map(([key, value]) => {
        const enValue = value.length ? value : key;
        const regex = /(\{\{.*?\}\}|<[^/>]+>|<\/[^>]+>|<[^/>]+\/>)/g;
        const parts = enValue.split(regex);
        const translatedParts = parts.map((part) => {
            if (regex.test(part)) {
                return part;
            }
            else {
                return part.replace(/[aeiou]/g, (char) => vowelMap[char]);
            }
        });
        let translatedValue = translatedParts.join("");
        const additionalLength = Math.round(translatedValue.length * languageExtraLength * 0.5);
        const additionalChars = Array.from({ length: additionalLength }, () => {
            const chars = "VWXYZ ";
            return chars.charAt(Math.floor(Math.random() * chars.length));
        }).join("");
        translatedValue = additionalChars + translatedValue + additionalChars;
        return [key, translatedValue];
    }));
    return result;
}
export function i18nFillOutEmptyValues(resource) {
    const result = Object.fromEntries(Object.entries(resource).map(([key, value]) => {
        const enValue = value.length ? value : key;
        return [key, enValue];
    }));
    return result;
}
export function i18nGetWordAndStringCount(resource) {
    let lineCount = 0;
    let wordCount = 0;
    Object.fromEntries(Object.entries(resource).map(([key, value]) => {
        const enValue = value.length ? value : key;
        const regex = /(\{\{.*?\}\}|<.*?>.*?<\/.*?>)/g;
        const parts = enValue.split(regex);
        parts.forEach((part) => {
            if (regex.test(part)) {
                wordCount += 1;
                return part;
            }
            else {
                const tmp = part.split(" ");
                wordCount += tmp.length;
                return part;
            }
        });
        ++lineCount;
        return [key, ""];
    }));
    return {
        wordCount,
        lineCount,
    };
}
